import axios from 'axios';

import { VehicleDefaultClass } from '../models/VehicleDefaultClass';

const uri = '/defaultclass/vehicle';

const getByCarrier = async (carrierId?: number) => {
  const url = carrierId ? `${uri}?carrierId=${carrierId}` : uri;
  const { data } = await axios.get<Record<string, number[]>>(url);
  return data;
};

const getAll = async () => {
  const { data } = await axios.get<Record<string, number[]>>(`${uri}`);
  return data;
};

const updateByCarrier = async (carrierId: number | undefined, vehicleDefaultClasses: VehicleDefaultClass[]) => {
  if (!carrierId) {
    throw new Error('carrierId is required for updateByCarrier');
  }
  const { data } = await axios.put<Record<string, number[]>>(`${uri}?carrierId=${carrierId}`, vehicleDefaultClasses);
  return data;
};

const updateGlobal = async (vehicleDefaultClasses: VehicleDefaultClass[]) => {
  const { data } = await axios.put<Record<string, number[]>>(`${uri}`, vehicleDefaultClasses);
  return data;
};

const create = async (vehicleDefaultClass: VehicleDefaultClass) => {
  const { data } = await axios.post<VehicleDefaultClass>(`${uri}`, vehicleDefaultClass);
  return data;
};

const update = async (vehicleDefaultClass: VehicleDefaultClass) => {
  const { data } = await axios.put<VehicleDefaultClass>(`${uri}/${vehicleDefaultClass.id}`, vehicleDefaultClass);
  return data;
};

const remove = async (vehicleDefaultClass: VehicleDefaultClass) => {
  const { data } = await axios.delete(`${uri}/${vehicleDefaultClass.id}`);
  return data;
};

const apis = {
  create,
  getAll,
  getByCarrier,
  remove,
  update,
  updateByCarrier,
  updateGlobal,
};

export default apis;
